import Footer from "./controller";

export default Footer;
